import React from 'react';
import createReactClass from 'create-react-class';
import ActivityAreaContainer from '../activityarea/ActivityAreaContainer';
import WithdrawalReceiptLine from './WithdrawalReceiptLine';
import withdrawalReceiptConfig from './config/withdrawalreceiptConfig';
import request from '../../helpers/request';
import setViewTitle from '../../helpers/setViewTitle';
import SimplePage from '../common/SimplePage';
import { Form, SubmitButton } from '../common/Forms';
import ItemAutoComplete from '../common/AutocompleteText';
import itemConfig from '../items/config/itemConfig';
import AjaxInProgressHOC from '../common/AjaxInProgressHOC';

var WithdrawalReceipt = createReactClass({

  componentWillMount() {
    setViewTitle('Entnahmedokument');
  },

  getInitialState() {
    return {
      withdrawalReceipt: {
        activityAreaId: '',
        activityLocationId: '',
        activityId: '',
        lines: []
      }
    };
  },

  onItemSelected(item) {
    this._itemAutoComplete.resetSelection();

    var {withdrawalReceipt} = this.state;

    withdrawalReceipt.lines.push({
      selectedItem: item
    });

    this.setState({
      withdrawalReceipt
    });
  },

  handleRemove(index) {
    let { lines } = this.state.withdrawalReceipt;
    lines.splice(index, 1);
    this.setState({
      lines: lines
    });
  },

  handleSubmit(data) {
    request.post({
      url: withdrawalReceiptConfig.apiUrl,
      data: data,
      success: () => {
        this.props.history.push('/items');
      }
    });
  },

  render() {
    var lines = this.state.withdrawalReceipt.lines.map((line, index) =>
      <WithdrawalReceiptLine
        item={line.selectedItem}
        index={index}
        key={line.selectedItem.id + '-' + index}
        onRemove={this.handleRemove}
      />
    );

    const footer = (
      <footer>
        <SubmitButton canSubmit={this.state.isValid && !this.props.isAjaxInProgress && this.state.withdrawalReceipt.lines.length > 0} title="Entnahme buchen" />
      </footer>
    );

    return (
      <SimplePage title="Entnahmedokument" icon="file-archive-o">

        <Form ref={c => this.form = c}
          onSubmit={this.handleSubmit}
          onValid={() => this.setState({isValid: true})}
          onInvalid={() => this.setState({isValid: false})}
          footer={footer}
          >

          <ActivityAreaContainer
            onActivityAreaChange={this.handleActivityAreaChange}
            onActivityLocationChange={this.handleActivityLocationChange}
            onActivityChange={this.handleActivityChange}
          />

          <br />
          <div className="table-responsive">
            <table className="table table-bordered table-striped">
              <thead>
                  <tr>
                      <th className="col-md-2">Artikel</th>
                      <th className="col-md-2">Lagerort</th>
                      <th className="col-md-1">Verfügbare Menge</th>
                      <th className="col-md-1">Menge</th>
                      <th className="col-md-1">Einheit</th>
                      <th>Aktionen</th>
                  </tr>
              </thead>
              <tbody>
                  {lines}

                  <tr>
                    <td style={{padding: 5}}>
                      <ItemAutoComplete
                        ref={c => this._itemAutoComplete = c}
                        dataUrl={itemConfig.itemsFastSearchUrl}
                        onSelect={this.onItemSelected}
                        searchPlaceholder="Artikel für Entnahme auswählen"
                        idProp="id"
                        displayProp="name"
                        inputTooShortText="Geben Sie mind. 0 Zeichen ein"
                        noMatchesText="Kein Ergebnis"
                        searchInProgressText="Suche..."
                        staticQueryParams={{ onlyInStock: true }}/>
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
              </tbody>
            </table>
          </div>
        </Form>
      </SimplePage>

    );
  }

});

export default AjaxInProgressHOC(WithdrawalReceipt);



// WEBPACK FOOTER //
// ./src/components/withdrawalreceipts/WithdrawalReceipt.js